module.exports = __webpack_public_path__ + "static/5StoryRichIndieGamesCuteFroggyProtagonists0-e1d7ec7464bb1e6cf8b5b2a2f91aa511.webp";